export default function(http) {
  return {
    //获取
    getInfo(data){
      return http.json({
        url: '/operationLog/cache/get',
        data
      })
    },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/cache.js